<template>
<SidebarComponent /> <!-- Aggiungi il componente sidebar qui -->
  <div class="dashboard-layout">
      <div class="content-container"> <!-- Contenitore per il contenuto principale -->
  <div class="card-container">

    <div class="titolo-card">
      <h1>Benvenuto nella tua dashboard</h1>
    </div>
    <!-- Immagine centrata -->
    <div class="card-image">
  <img src="https://www.metodofusco.it/media/image_desktop_studi.jpg" alt="Descrizione dell'immagine">
    </div>


  
    <div class="card-header2" @click="goToCreateOrder">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">confirmation_number</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Crea un nuovo ordine</div>
    <div class="text-card">Seleziona categoria e tipo di prodotti.</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>


<div class="card-header2" @click="goToCreateSpesa">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">confirmation_number</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Carica una spesa</div>
    <div class="text-card">Seleziona categoria e tipo di prodotti.</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>



<div class="card-header2" @click="goToReadOrder">
  <!-- Colonna 1: solo icona -->
  <div class="icon-column">
    <span class="material-icons">restaurant_menu</span>
  </div>
  
  <!-- Colonna 2: Titolo e Descrizione -->
  <div class="text-column">
    <div class="header-text">Ricerca un ordine</div>
    <div class="text-card">Visualizza gli ultimi ordini.</div>
  </div>
  
  <!-- Colonna 3: icona attaccata al bordo destro -->
  <div class="icon-column-right">
      <span class="material-icons">chevron_right</span>
  </div>
</div>


</div>
  </div>
</div>
</template>

<script>

// Importa le librerie necessarie
import { useRouter } from 'vue-router';  // Importa useRouter
import { ref } from 'vue';
import { getAuth, signOut } from 'firebase/auth'; // Importa le funzioni di autenticazione di Firebase

import SidebarComponent from '../SidebarComponent.vue'; // Importa SidebarComponent


export default {

  components: {
    SidebarComponent // Registra il componente SidebarComponent
  },
  
  setup() {
    const userTickets = ref([]);

    const router = useRouter();  // Ottieni l'istanza del router


    const goBack = () => {
      router.go(-1); // Naviga alla pagina precedente
    };

    const viewAlimentazione = async () => {
      // Il tuo codice esistente per viewAlimentazione
      // ...
    };

    const goToReadOrder = () => {
      router.push('/order-list');  // Usa l'istanza del router
    };


    const goToCreateSpesa = () => {
      router.push('/uscite');  // Usa l'istanza del router
    };



    const goToCreateTicket = () => {
      router.push('/create-ticket');  // Usa l'istanza del router
    };

    const goToVideoCall = () => {
      router.push('/video-call-page'); // Indirizza al componente RicetteComponent.vue
    };

    const goToRicette = () => {
      router.push('/ricetta'); // Indirizza al componente RicetteComponent.vue
    };

    const goToCreateOrder = () => {
      router.push('/order'); // Indirizza al componente RicetteComponent.vue
    };

    const viewConversation = (ticketId) => {
      router.push({ name: 'UserTicketConversation', params: { ticketId } });
    };

    const handleLogout = async () => {
      const auth = getAuth();
      try {
        await signOut(auth);
        router.push('/');
      } catch (error) {
        console.error("Errore durante il logout:", error);
      }
    };




    return {
      userTickets,
      goToCreateTicket,
      viewConversation,
      goToRicette,
      viewAlimentazione,
      handleLogout,  // Aggiungi questa funzione all'output
      goToVideoCall,
      goToCreateOrder,
      goBack,
      goToReadOrder,
      goToCreateSpesa
    };
  },
};


</script>

  
<style scoped>


</style>
